export default {
    apiKey: "AIzaSyBDmisH6ZmZiP0zzCTs977-SIREl7dMyKM",
    authDomain: "motherapp-9529a.firebaseapp.com",
    databaseURL: "https://motherapp-9529a.firebaseio.com",
    projectId: "motherapp-9529a",
    storageBucket: "motherapp-9529a.appspot.com",
    messagingSenderId: "532815602348",
    appId: "1:532815602348:web:903f70fca23dd625"
};